import { useCallback } from 'react';

import { useCoreDispatch } from '@pp/core/src/store/CoreStore';
import { useConfigSlice } from '@pp/core/src/store/slices/config/selectors';

import { fetchLastGameDataAction } from '../../store/apiActions/fetchLastGameDataAction';

export const useLastGameDataFetcher = () => {
  const dispatch = useCoreDispatch();
  const tableId = useConfigSlice.tableId();
  const gsAddress = useConfigSlice.env()?.gameStats;
  const indexOf = useConfigSlice.env()?.gameStats?.indexOf('.');
  const env = useConfigSlice.env();
  const gsAddressWithBaseURL =
    (env?.playerBaseDomain && gsAddress?.replace(gsAddress.slice(indexOf), `.${env?.playerBaseDomain}`)) || gsAddress;
  const jwtToken = useConfigSlice.playerConfig()?.jwtToken ?? '';
  const countPerPage = 20;

  return useCallback(
    (show: boolean, page: number = 1, gameId?: string) => {
      if (gsAddressWithBaseURL && tableId) {
        dispatch(
          fetchLastGameDataAction({
            'table-id': tableId,
            url: `${gsAddressWithBaseURL}/api/game/stats/lastGame`,
            JWTTOKEN: jwtToken,
            pageNum: 1,
            pageSize: page * countPerPage,
            'game-id': gameId,
            force: show,
          })
        );
      }
    },
    [dispatch, gsAddressWithBaseURL, tableId]
  );
};
